import axios from "../api/axios";
import constants from "../constants";
import { useState } from "react";
import useAxiosPrivate from "./useAxiosPrivate";

const useS3FileManagement = () => {
  const axiosPrivate = useAxiosPrivate();
  const [progress, setProgress] = useState(0);

  const validTypes = ["HOST", "DP", null, undefined];

  const getContentType = (extension) => {
    const mimeTypes = {
      css: "text/css",
      png: "image/png",
      mp4: "video/mp4",
      gif: "image/gif",
      html: "text/html",
      jpg: "image/jpeg",
      txt: "text/plain",
      jpeg: "image/jpeg",
      jfif: "image/jpeg",
      pdf: "application/pdf",
      zip: "application/zip",
      json: "application/json",
      js: "application/javascript",
    };

    return mimeTypes[extension] || "application/octet-stream";
  };

  const getPreSignedUrl = async (
    key,
    type,
    fileType,
    operation = "PUT",
    uploadId,
    partNumber
  ) => {
    // console.log(
    //   "key,type,fileType,operation = PUT,uploadId,partNumber",
    //   key,
    //   type,
    //   fileType,
    //   operation,
    //   uploadId,
    //   partNumber
    // );

    try {
      if (!key) throw new Error("Missing parameters: key");
      if (!validTypes.includes(type)) {
        throw new Error("Invalid type. Must be 'HOST' or 'DB'");
      }
      console.log("fileType", fileType);
      if (Array.isArray(key) || Array.isArray(fileType)) {
        console.log("Array conditin:");
        const { data } = await axiosPrivate.post(
          "node/s3/get-signed-url",
          {
            key,
            type,
            uploadId,
            partNumber,
            fileType,
            operation,
          },
          {
            headers: {
              Authorization: type === "DP" ? "abdjcdifouvn" : undefined,
              "Content-type": "application/json",
            },
          }
        );
        return data;
      } else {
        const contentType = getContentType(fileType);

        const { data } = await axiosPrivate.post(
          "node/s3/get-signed-url",
          {
            key,
            type,
            uploadId,
            partNumber,
            contentType,
            operation,
          },
          {
            headers: {
              // Use hardcoded auth for DP type to bypass JWT validation
              Authorization: type === "DP" ? "abdjcdifouvn" : undefined,
              "Content-Type": "application/json",
            },
          }
        );
        return data;
      }
    } catch (error) {
      console.error("error in get presigned url", error);
      throw error;
    }
  };

  const getS3Object = async (key, type, responseType = "stream") => {
    try {
      if (!key) throw new Error("Missing parameters: key");

      if (!validTypes.includes(type)) {
        throw new Error("Invalid type. Must be 'HOST' or 'DB'");
      }

      const res = await axiosPrivate.get(
        `node/s3/file?key=${key}&type=${type}`,
        {
          responseType,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return res;
    } catch (error) {
      console.error("error in get s3 object", error);
      throw error;
    }
  };

  const startMultiPartUpload = async (key, size, mimeType, type) => {
    try {
      if (!key || !size || !mimeType)
        throw new Error("Missing parameters: key, size, mimeType");

      if (!validTypes.includes(type)) {
        throw new Error("Invalid type. Must be 'HOST' or 'DB'");
      }

      const { data } = await axiosPrivate.post(
        "node/s3/upload/start",
        {
          key,
          size,
          mimeType,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Data from api:", data);

      return data;
    } catch (error) {
      console.error("error in start multi upload  s3 object", error);
      throw error;
    }
  };

  const completeMultipartUpload = async (key, uploadId, parts = [], type) => {
    try {
      if (!key || !uploadId || !parts?.length)
        throw new Error("Missing parameters: key, uploadId, parts");

      if (!validTypes.includes(type)) {
        throw new Error("Invalid type. Must be 'HOST' or 'DB'");
      }

      const { data } = await axiosPrivate.post(
        "node/s3/upload/complete",
        {
          key,
          uploadId,
          parts,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return data;
    } catch (error) {
      console.error("error in complete multi part upload  s3 object", error);
      throw error;
    }
  };

  const deleteS3Objects = async (key, type) => {
    try {
      if (!key) throw new Error("Missing parameters: key");

      if (!validTypes.includes(type)) {
        throw new Error("Invalid type. Must be 'HOST' or 'DB'");
      }

      await axiosPrivate.delete(
        "node/s3/file",
        {
          key,
          type,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return "Success";
    } catch (error) {
      console.error("error in complete multi part upload  s3 object", error);
      throw error;
    }
  };

  // const onMultiPartUpload = async (key, file, type) => {
  //   try {
  //     if (!file || !key) {
  //       throw new Error("Missing parameters: key, file");
  //     }

  //     if (!validTypes.includes(type)) {
  //       throw new Error("Invalid type. Must be 'HOST' or 'DB'");
  //     }

  //     console.log("key:", key, "file:", file);

  //     const size = file.size,
  //       mimeType = file.type
  //         ? file.type
  //         : getContentType(file.name?.replace(/^.*\./, ""));

  //     // get upload id and presignedUrls to start upload
  //     console.log("key, size, mimeType: before passing",key, size, mimeType);
      
  //     const data = await startMultiPartUpload(key, size, mimeType);
  //     //   if (data.resultCode === constants.RESULT_STATUS.SUCCESS) {
  //     console.log("Data from function::::::::::::",data);
      
  //     const { uploadId, presignedUrls } = data;
  //     console.log("uploadId:", uploadId, "presignedUrls:", presignedUrls);

  //     // Split file into chunks and upload in parallel
  //     const CHUNK_SIZE = 16 * 1024 * 1024;
  //     const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
  //     const uploadedParts = [];
  //     let uploadedBytes = 0;

  //     // Create upload promises for all chunks
  //     const uploadPromises = Array.from({ length: totalChunks }, (_, index) => {
  //       const partNumber = index + 1;
  //       const start = index * CHUNK_SIZE;
  //       const end = Math.min(start + CHUNK_SIZE, size);
  //       const chunk = file.slice(start, end);

  //       const presignedUrl = presignedUrls?.find(
  //         (u) => u.partNumber === partNumber
  //       )?.url;

  //       if (!presignedUrl) {
  //         throw new Error(`Missing URL for part ${partNumber}`);
  //       }

  //       return axios
  //         .put(presignedUrl, chunk, {
  //           headers: { "Content-Type": file.type },
  //           onUploadProgress: (evt) => {
  //             // Update progress more accurately
  //             const newUploadedBytes = uploadedBytes + evt.loaded;
  //             const percent = Math.round((newUploadedBytes / file.size) * 100);
  //             setProgress(percent);
  //           },
  //         })
  //         .then((res) => {
  //           uploadedBytes += chunk.size;
  //           uploadedParts.push({
  //             ETag: res.headers["etag"],
  //             PartNumber: partNumber,
  //           });
  //         });
  //     });

  //     // Upload chunks with concurrency control
  //     const MAX_CONCURRENT_UPLOADS = 3;
  //     await Promise.all(
  //       Array.from({ length: MAX_CONCURRENT_UPLOADS }, (_, i) =>
  //         uploadPromises.filter(
  //           (_, index) => index % MAX_CONCURRENT_UPLOADS === i
  //         )
  //       ).map((chunkPromises) => Promise.all(chunkPromises))
  //     );

  //     // Sort parts by part number (required by S3)
  //     uploadedParts.sort((a, b) => a.PartNumber - b.PartNumber);

  //     await completeMultipartUpload(key, uploadId, uploadedParts);
  //     setProgress(100);
  //     //   }
  //     return "Success";
  //   } catch (error) {
  //     console.error("error in multi part upload to s3 object", error);
  //     throw error;
  //   }
  // };

const onMultiPartUpload = async (key, file, type) => {
    try {
      // Enhanced parameter validation
      if (!key || !file) {
        throw new Error("Missing parameters: key and file are required");
      }

      if (!validTypes.includes(type)) {
        throw new Error("Invalid type. Must be 'HOST' or 'DB'");
      }

      console.log("key:", key, "file:", file, "type:", type);

      // Safe size and mimeType extraction
      const size = file?.size;
      let mimeType = file?.type || getContentType(file?.name?.replace(/^.*\./, "") || "");

      // Validate extracted values
      if (!size || size === 0) {
        throw new Error("Invalid file: File size is zero or undefined");
      }

      if (!mimeType) {
        throw new Error("Could not determine file content type");
      }

      // get upload id and presignedUrls to start upload
      console.log("key, size, mimeType: before passing", key, size, mimeType);
      
      // Call startMultiPartUpload with proper parameters
      const data = await startMultiPartUpload(key, size, mimeType);
      
      // Validate API response
      if (!data) {
        throw new Error("No response received from startMultiPartUpload");
      }

      // Check if the API returned an error result code
      if (data.resultCode !== undefined && data.resultCode !== constants.RESULT_STATUS.SUCCESS) {
        throw new Error(data.msg || "Failed to start multipart upload");
      }

      console.log("Data from function::::::::::::", data);
      
      const { uploadId, presignedUrls } = data;
      
      // Validate response data
      if (!uploadId || !presignedUrls || !Array.isArray(presignedUrls)) {
        throw new Error("Invalid response: missing uploadId or presignedUrls");
      }

      console.log("uploadId:", uploadId, "presignedUrls:", presignedUrls);

      // Split file into chunks and upload in parallel
      const CHUNK_SIZE = 16 * 1024 * 1024; // 16MB chunks
      const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
      const uploadedParts = [];
      let uploadedBytes = 0;

      // Validate presigned URLs match expected chunks
      if (presignedUrls.length !== totalChunks) {
        console.warn(`Presigned URLs count (${presignedUrls.length}) doesn't match expected chunks (${totalChunks})`);
      }

      // Create upload promises for all chunks
      const uploadPromises = Array.from({ length: totalChunks }, (_, index) => {
        const partNumber = index + 1;
        const start = index * CHUNK_SIZE;
        const end = Math.min(start + CHUNK_SIZE, size);
        const chunk = file.slice(start, end);

        // Find presigned URL for this part number
        const presignedUrl = presignedUrls.find(
          (u) => u.partNumber === partNumber
        )?.url;

        if (!presignedUrl) {
          throw new Error(`Missing URL for part ${partNumber}`);
        }

        return axios
          .put(presignedUrl, chunk, {
            headers: { 
              "Content-Type": mimeType,
              "Content-Length": chunk.size
            },
            onUploadProgress: (evt) => {
              if (evt.loaded && evt.total) {
                const chunkProgress = (evt.loaded / evt.total) * (chunk.size / file.size) * 100;
                const newUploadedBytes = uploadedBytes + evt.loaded;
                const percent = Math.min(99, Math.round((newUploadedBytes / file.size) * 100));
                setProgress(percent);
              }
            },
          })
          .then((res) => {
            uploadedBytes += chunk.size;
            uploadedParts.push({
              ETag: res.headers.etag || res.headers.ETag,
              PartNumber: partNumber,
            });
          })
          .catch((error) => {
            console.error(`Failed to upload part ${partNumber}:`, error);
            throw new Error(`Part ${partNumber} upload failed: ${error.message}`);
          });
      });

      // Upload chunks with concurrency control
      const MAX_CONCURRENT_UPLOADS = 3;
      const chunkedPromises = [];
      
      for (let i = 0; i < MAX_CONCURRENT_UPLOADS; i++) {
        const chunkPromises = uploadPromises.filter(
          (_, index) => index % MAX_CONCURRENT_UPLOADS === i
        );
        chunkedPromises.push(Promise.all(chunkPromises));
      }

      await Promise.all(chunkedPromises);

      // Sort parts by part number (required by S3)
      uploadedParts.sort((a, b) => a.PartNumber - b.PartNumber);

      console.log("All parts uploaded, completing multipart upload...");
      await completeMultipartUpload(key, uploadId, uploadedParts);
      
      setProgress(100);
      return "Success";
    } catch (error) {
      console.error("Error in multi part upload to S3:", error);
      setProgress(0); // Reset progress on error
      throw error;
    }
  };

  const onUploadS3Object = async (
    key,
    file,
    fileType,
    type,
    operation = "PUT",
    uploadId,
    partNumber
  ) => {
    try {
      const { url } = await getPreSignedUrl(
        key,
        type,
        fileType,
        operation,
        uploadId,
        partNumber
      );
      console.log("url", url);

      if (url) {
        const res = await uploadWithPresign(
          url,
          operation,
          file,
          fileType,
          type
        );
        return res;
      } else throw new Error("Please check the s3 object key.");
    } catch (error) {
      console.error("error in upload file to s3 using presigned url", error);
      throw error;
    }
  };

  const uploadWithPresign = async (
    url,
    method = "PUT",
    file,
    fileType,
    type
  ) => {
    try {
      if (!url) {
        throw new Error("Missing parameter: URL");
      }

      if (!validTypes.includes(type)) {
        throw new Error("Invalid type. Must be 'HOST' or 'DB'");
      }

      const res = await axios({
        method,
        url,
        data: file,
        headers: {
          "Content-Type": getContentType(fileType),
        },
      });
      return res;
    } catch (error) {
      console.error("error in upload file to s3 using presigned url", error);
      if (error.code === "ERR_BAD_REQUEST")
        throw new Error(
          `Upload failed. You don't have permission to upload/open this file. Please contact gradious team.`
        );
      throw error;
    }
  };

  const getS3FileAsFile = async (key, type) => {
    try {
      if (!key) {
        throw new Error("Missing parameters: key");
      }

      if (!validTypes.includes(type)) {
        throw new Error("Invalid type. Must be 'HOST' or 'DB'");
      }
      // const res = await getS3Object(key, type, "blob");
      const { url } = await getPreSignedUrl(key, type, "", "GET");
      console.log("url", url);

      const res = await axios({
        method: "GET",
        url,
      });

      console.log("res:", res);

      // const contentType =
      //   res.headers["content-type"] || "application/octet-stream";

      // const filename =
      //   res.headers["content-disposition"]
      //     ?.split("filename=")[1]
      //     ?.replace(/"/g, "") || key.split();

      const contentType = key.split(".")?.pop();
      const filename = key.split("/").pop();

      console.log("contentType:", contentType, "filename:", filename);

      const fileObj = new File([res.data], filename, {
        type: getContentType(contentType),
      });

      return fileObj;
    } catch (error) {
      console.error("error in get s3 file as file", error);
      throw error;
    }
  };

  const getFileData = async (key, type) => {
    try {
      if (!key) {
        throw new Error("Missing parameters: key");
      }

      if (!validTypes.includes(type)) {
        throw new Error("Invalid type. Must be 'HOST' or 'DB'");
      }

      if (key.length >= 0) {
        console.log("key:", key, "type:", type);

        const data = await getPreSignedUrl(key, type, "", "GET");
        console.log("data from preSigneedUrl:", data);
        let arrRes = [];
        for (let i = 0; i < data.url.length; i++) {
          const keyParts = data.url[i].split("?");
          const fileUrl = keyParts[0];
          const keyParts1 = fileUrl.split(".");
          const fileType = getContentType(keyParts1[keyParts1.length - 1].toLowerCase());
          console.log("fileType:",fileType);
          const isImage = fileType === "image/png";
          const res = await axios({
            method: "GET",
            url: data.url[i],
            responseType:isImage?'arraybuffer':'text'
          });
          console.log("res:", res);
          arrRes.push(res);
        }
        return arrRes;
      } else {
        const { url } = await getPreSignedUrl(key, type, "", "GET");
        console.log("url", url);

        const res = await axios({
          method: "GET",
          url,
        });

        console.log("res:", res);
        return res.data;
      }
    } catch (error) {
      console.error("error in get s3 file data", error);
      throw error;
    }
  };

  const getFileDataByfolder = async (key, type) => {
    try {
      if (!key) {
        throw new Error("Missing parameters: key");
      }

      if (!validTypes.includes(type)) {
        throw new Error("Invalid type. Must be 'HOST' or 'DB'");
      }
      console.log("key:",key,"type:",type);
      
      const { contents } = await listObjectsByFolder(key, type);
      console.log("contents:", contents);

      // if (contents) {
      //   const filePromises = contents.map(async (file) => {
      //     const data = await getFileData(file.Key, type);
      //     let fileContents;
      //     const keyParts = file.Key.split(".");
      //     const fileType = keyParts[keyParts.length - 1].toLowerCase();
      //     if (fileType.includes("image"))
      //       fileContents = new Blob([data], { type: fileType });
      //     else if (fileType.includes("json"))
      //       fileContents = JSON.stringify(data,null,2);
      //     else fileContents = data;
      //     return {
      //       fileContents,
      //       contentType: fileType,
      //       filename: file.Key.replace(key, ""),
      //     };
      //   });
      //   const files = await Promise.all(filePromises);
      //   return files;
      // }

      if (contents) {
        let allFileArray = [];
        contents.map((file) => allFileArray.push(file.Key));
        console.log("allFileArray:", allFileArray);
        const data = await getFileData(allFileArray, type);
        console.log("DATTATTTATTA:", data);

        const filePromises = allFileArray.map(async (keys, index) => {
          let fileContents;
          const keyParts = keys.split(".");
          const fileType = getContentType(
            keyParts[keyParts.length - 1].toLowerCase()
          );
          if (fileType.includes("image")) {
            const blob = new Blob([data[index].data], { type: fileType });
    
            fileContents = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.readAsDataURL(blob);
            });

          } else if (fileType.includes("json"))
            fileContents = JSON.stringify(data?.[index]?.data, null, 2);
          else fileContents = data?.[index]?.data;
          return {
            fileContents,
            contentType: fileType,
            filename: keys.replace(key, ""),
          };
        });

        const files = await Promise.all(filePromises);
        return files;
      }
      return {};
    } catch (error) {
      console.error("error in get s3 object by folder", error);
      throw error;
    }
  };

  const listObjectsByFolder = async (key, type) => {
    try {
      if (!key) {
        throw new Error("Missing parameters: key");
      }

      if (!validTypes.includes(type)) {
        throw new Error("Invalid type. Must be 'HOST' or 'DB'");
      }

      const { data } = await axiosPrivate.post(
        "node/s3/list",
        {
          key,
          type,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return data;
    } catch (error) {
      console.error("error in list s3 object by folder", error);
      throw error;
    }
  };

  const getS3ObjectsByFolder = async (key, type) => {
    try {
      if (!key) {
        throw new Error("Missing parameters: key");
      }

      if (!validTypes.includes(type)) {
        throw new Error("Invalid type. Must be 'HOST' or 'DB'");
      }

      const { contents } = await listObjectsByFolder(key, type);
      console.log("contents:", contents);

      if (contents) {
        const filePromises = contents.map(async (file) => {
          const fileObj = await getS3FileAsFile(file.Key, type);
          let fileContents;

          if (fileObj.type.includes("image")) {
            const blob = await new Response(fileObj, {
              headers: {
                "Content-Type": fileObj.type,
              },
            }).blob();

            fileContents = await new Promise((resolve) => {
              const reader = new FileReader();

              reader.onloadend = () => resolve(reader.result);
              reader.readAsDataURL(blob);
            });
          } else fileContents = fileObj.text();
          return {
            fileContents,
            contentType: fileObj.type,
            filename: file.Key.replace(key + "/", ""),
          };
        });
        const files = await Promise.all(filePromises);
        return files;
      }
      return {};
    } catch (error) {
      console.error("error in get s3 object by folder", error);
      throw error;
    }
  };

  return {
    getPreSignedUrl,
    getS3Object,
    startMultiPartUpload,
    completeMultipartUpload,
    deleteS3Objects,
    onMultiPartUpload,
    getContentType,
    uploadWithPresign,
    onUploadS3Object,
    getS3FileAsFile,
    getFileData,
    getFileDataByfolder,
    listObjectsByFolder,
    getS3ObjectsByFolder,
    progress,
  };
};

export default useS3FileManagement;
